import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { fmtErr, API } from "../../lib/api";
import { PageHeader, EmptyState } from "../../components/bits";
import { Award, Download, Target, Trophy } from "lucide-react";

const MONTHS_AR = { "01": "يناير", "02": "فبراير", "03": "مارس", "04": "أبريل", "05": "مايو", "06": "يونيو",
  "07": "يوليو", "08": "أغسطس", "09": "سبتمبر", "10": "أكتوبر", "11": "نوفمبر", "12": "ديسمبر" };
const monthAr = (m) => { const [y, mm] = (m || "").split("-"); return `${MONTHS_AR[mm] || mm} ${y || ""}`; };

export default function Certificates() {
  const [certs, setCerts] = useState(null);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/portal/certificates").then((r) => setCerts(r.data)).catch((e) => toast.error(fmtErr(e)));
    api.get("/portal/dashboard").then((r) => setStats(r.data.stats)).catch(() => {});
  }, []);

  if (!certs) return <div className="text-center text-mutext py-20 font-head">جارٍ التحميل …</div>;

  return (
    <div data-testid="certificates-page">
      <PageHeader title="سجل الشهادات والأوسمة" sub="أرشيفك الدائم من شهادات الشكر الشهرية ووسام تحقيق المستهدف — جاهزة للطباعة والتصدير" />

      <h2 className="font-head font-bold text-base mb-3 flex items-center gap-2">
        <Award className="w-4 h-4 text-coral-600" /> شهادات الشكر الشهرية ({certs.length})
      </h2>
      {certs.length === 0 ? (
        <EmptyState testid="certificates-empty" text="لم تحصل على شهادة شهرية بعد — استمر في تميّزك وستصلك شهادتك المعتمدة من المدير العام فور استحقاقها" />
      ) : (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
          {certs.map((c) => (
            <div key={c.id} data-testid={`certificate-card-${c.id.slice(0, 8)}`}
              className="bg-surface rounded-3xl border border-brd shadow-md overflow-hidden">
              <div className="p-5 text-white" style={{ background: "linear-gradient(120deg,#0B6E7A,#12939E 60%,#FF7A59)" }}>
                <Award className="w-7 h-7 mb-2" />
                <div className="font-head font-black text-lg">{c.title}</div>
                <div className="text-[11px] text-white/80 mt-1">{monthAr(c.month)}</div>
              </div>
              <div className="p-5">
                <div className="text-sm font-bold mb-1">{c.coordinator_name}</div>
                <div className="text-[11px] text-mutext mb-1">{c.school_name}</div>
                <div className="text-[11px] text-mutext mb-4">اعتمدها: {c.issued_by} · {(c.created_at || "").slice(0, 10)}</div>
                <button data-testid={`certificate-download-${c.id.slice(0, 8)}`}
                  onClick={() => window.open(`${API}/portal/certificates/${c.id}/pdf`, "_blank")}
                  className="w-full rounded-xl bg-coral-600 hover:bg-coral-900 text-white text-xs font-bold px-4 py-2.5 flex items-center justify-center gap-2 transition-colors">
                  <Download className="w-4 h-4" /> تحميل الشهادة (PDF)
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {stats && (
        <div data-testid="target-badge-card" className="bg-surface rounded-3xl border border-brd shadow-md p-6 mt-8">
          <div className="flex items-center gap-2 mb-4">
            <Target className="w-5 h-5 text-turq-600" />
            <b className="font-head text-base">وسام تحقيق المستهدف 90%</b>
          </div>
          {stats.pct >= 90 ? (
            <div className="text-center py-4">
              <Trophy className="w-14 h-14 mx-auto text-coral-600 mb-3" />
              <div data-testid="badge-earned" className="font-head font-black text-lg text-turq-900 dark:text-turq-300">
                مبارك! حصلت مدرستك على الوسام — حققت المستهدف بنسبة {stats.pct}%
              </div>
              <p className="text-xs text-mutext mt-1">إنجاز يُخلَّد في سجل مدرستك… نحو تميّزٍ مستدام</p>
            </div>
          ) : (
            <div className="text-center py-2">
              <Target className="w-12 h-12 mx-auto text-mutext/40 mb-3" />
              <div className="h-2.5 rounded-full bg-surface2 overflow-hidden max-w-md mx-auto mb-3">
                <div className="h-full rounded-full bg-coral-600 transition-all duration-700"
                  style={{ width: `${Math.min(100, stats.pct || 0)}%` }} />
              </div>
              <p data-testid="badge-progress-text" className="text-[12px] text-mutext">
                نسبة التمكين الحالية <b className="text-coral-600">{stats.pct}%</b> — الهدف القادم: رفع مشاركة الطلبة للوصول إلى المستهدف 90% ونيل الوسام
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
